import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-up-arrow-alt" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['go-top active', { active: _ctx.isTop }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToTop()))
  }, _hoisted_2, 2))
}